import React, { useEffect, useState } from "react";
import { getCustomerDeliveriesAddressList } from "api/CustomerDeliveries";

interface AddressModalProps {
    open: boolean;
    onClose?: () => void;
    onSubmit?: (address: any) => void;
    onOpenAdd?: (address?: any) => void;
}

export default function AddressModal({ open, onClose, onSubmit, onOpenAdd }: AddressModalProps) {
    const [addresses, setAddresses] = useState<any[]>([]);
    const [selected, setSelected] = useState<number | string>("");

    useEffect(() => {
        if (open) {
            getCustomerDeliveriesAddressList().then(res => {
                if (res.status && res.data.items) {
                    setAddresses(res.data.items);
                    const defaultAddr = res.data.items.find(a => a.is_default);
                    if (defaultAddr) {
                        setSelected(defaultAddr.id);
                    } else if (res.data.items.length > 0) {
                        setSelected(res.data.items[0].id);
                    }
                }
            }).catch(console.error);
        }
    }, [open]);

    if (!open) return null;

    const handleConfirm = () => {
        const addr = addresses.find(a => a.id === selected);
        if (addr && onSubmit) {
            onSubmit(addr);
        }
        onClose?.();
    };

    return (
        <>
            <div
                role="presentation"
                className="MuiDialog-root styles_address_dialog__cp8hp"
                style={{ position: "fixed", zIndex: 1300, inset: 0 }}
            >
                <div
                    className="MuiBackdrop-root"
                    aria-hidden="true"
                    onClick={onClose}
                />

                <div className="MuiDialog-container MuiDialog-scrollPaper">

                    <div className="MuiPaper-root MuiDialog-paper MuiDialog-paperScrollPaper MuiDialog-paperWidthSm MuiPaper-elevation24 MuiPaper-rounded">

                        {/* ------ TITLE ------ */}
                        <div className="MuiDialogTitle-root styles_title__S616r">
                            <h2 className="MuiTypography-root MuiTypography-h6">
                                Chọn địa chỉ nhận hàng
                            </h2>
                        </div>

                        {/* ------ CONTENT ------ */}
                        <div className="MuiDialogContent-root MuiDialogContent-dividers">

                            <form>
                                <div className="MuiGrid-root styles_deliveryCardList__vFEBY MuiGrid-container">

                                    {/* ================== LIST ADDRESS ================== */}
                                    <div
                                        className="MuiGrid-root styles_formContainer___MbmL MuiGrid-item MuiGrid-grid-xs-12"
                                    >
                                        {addresses.map((item, index) => (
                                            <div key={item.id} className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                                                <div className="MuiGrid-root MuiGrid-container">
                                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                                                        <div
                                                            className={
                                                                "MuiFormGroup-root styles_radioGroup__BV60H " +
                                                                (selected === item.id
                                                                    ? "styles_radioGroupSelect__M0coO"
                                                                    : "")
                                                            }
                                                        >
                                                            <label className="MuiFormControlLabel-root">

                                                                <span
                                                                    className={
                                                                        "MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root styles_checkbox__gzU9V MuiRadio-colorSecondary jss2 Mui-checked MuiIconButton-colorSecondary !p-[9px] " +
                                                                        (selected === item.id
                                                                            ? "styles_checkbox__gzU9V Mui-checked"
                                                                            : "styles_unCheckedCheckbox__EzbzQ")
                                                                    }
                                                                >
                                                                    <span className="MuiIconButton-label">
                                                                        <input
                                                                            className="jss4"
                                                                            type="radio"
                                                                            value={item.id}
                                                                            checked={selected === item.id}
                                                                            onChange={() => setSelected(item.id)}
                                                                        />
                                                                        <div
                                                                            className={
                                                                                "jss5 " +
                                                                                (selected === item.id
                                                                                    ? "jss7"
                                                                                    : "")
                                                                            }
                                                                        >
                                                                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                                                            </svg>
                                                                            <svg className="MuiSvgIcon-root jss6 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                                                            </svg>
                                                                        </div>
                                                                    </span>
                                                                </span>

                                                                <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">

                                                                    <div className="MuiGrid-root styles_groupInfo__z1wHS">

                                                                        <div className="styles_colInfoShip__NciP7">

                                                                            <div className="styles_item__5pnGA">
                                                                                <h6 className="MuiTypography-root styles_title__h1tN8">
                                                                                    Địa chỉ
                                                                                </h6>

                                                                                {item.is_default === 1 && (
                                                                                    <div className="styles_isDefault__DAWTE">
                                                                                        <h6 className="MuiTypography-root MuiTypography-h6">
                                                                                            Mặc định
                                                                                        </h6>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <button
                                                                                type="button"
                                                                                className="MuiButtonBase-root MuiButton-root MuiButton-text styles_textEdit__iMHSw"
                                                                                onClick={() => onOpenAdd?.(item)}
                                                                            >
                                                                                <span className="MuiButton-label">Sửa</span>
                                                                            </button>
                                                                        </div>
                                                                        <div className="styles_item__5pnGA">
                                                                            <img className="w-4 h-4" src="https://cdn-web-next.thuocsi.vn/icons/checkout/Person.svg" alt="Person Icon" />
                                                                            <h6 className="MuiTypography-root styles_text__vtQbd undefined MuiTypography-h6">{item.name}</h6>
                                                                        </div>

                                                                        <div className="styles_item__5pnGA">
                                                                            <img className="w-4 h-4" src="https://cdn-web-next.thuocsi.vn/icons/checkout/Phone.svg" alt="Person Icon" />
                                                                            <h6 className="MuiTypography-root styles_text__vtQbd undefined MuiTypography-h6">{item.phone}</h6>
                                                                        </div>

                                                                        <div className="styles_item__5pnGA">
                                                                            <img className="w-4 h-4" src="https://cdn-web-next.thuocsi.vn/icons/checkout/Check_In_Pin.svg" alt="Person Icon" />
                                                                            <h6 className="MuiTypography-root styles_text__vtQbd undefined MuiTypography-h6">
                                                                                {item.address}
                                                                                {item.ward && `, ${item.ward}`}
                                                                                {item.district && `, ${item.district}`}
                                                                                {item.province && `, ${item.province}`}
                                                                            </h6>
                                                                        </div>

                                                                    </div>

                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* ================== ADD NEW ADDRESS BUTTON ================== */}
                                    <div className="MuiGrid-root styles_buttonAddmoreWrapper__9UvDt MuiGrid-item MuiGrid-grid-xs-12">
                                        <button
                                            type="button"
                                            className="MuiButtonBase-root MuiButton-root MuiButton-text styles_card__9H3QU"
                                            onClick={() => onOpenAdd?.()}
                                        >
                                            <span className="MuiButton-label">
                                                <div className="styles_add_icon_column__LUhdp">
                                                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AddCircleOutlineIcon">
                                                        <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"></path>
                                                    </svg>
                                                    <b className="styles_textAdd__SB4kV">Thêm địa chỉ mới </b>
                                                </div>
                                            </span>
                                            <span className="MuiTouchRipple-root"></span>
                                        </button>
                                    </div>

                                    {/* ================== CONFIRM BUTTON ================== */}
                                    <div className="MuiGrid-root styles_buttonSubmitWrapper__dW2px MuiGrid-item MuiGrid-grid-xs-12">
                                        <button
                                            type="button"
                                            className="MuiButtonBase-root MuiButton-root styles_sendData__UXMGO"
                                            onClick={handleConfirm}
                                        >
                                            <span className="MuiButton-label">Xác nhận</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}
